import { useEffect } from "react";
import { format } from 'date-fns';
import { datadogLogs } from '@datadog/browser-logs';

const Home = () => {

  useEffect(() => {
    datadogLogs.logger.debug('Page Visited', { 
      name: 'Home',
      timestamp: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
      service: 'Restaurant Default',
      env: 'uat',
      version: '0.0.1',
      organisation: 'TYIMXJyrsby3hAf4Z1Wk',
      storeId: 'fm-generic',
    });
  }, [])

  return (
    <div>Home</div>
  );
}

export default Home;
